import {Placement} from '@popperjs/core';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Handler, HandlerOf, RendererOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {PopoverCoordinator} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {SearchAccountsDropdown} from '../dropdowns/search/searchAccountsDropdown';
import {InlineEditingInputDisplay} from './inlineEditingInputDisplay';

/*
 * Types.
 */

interface InlineEditingAccountPopoverProps {
  className?: string;
  onEditSave: HandlerOf<number>;
  onEditCancel: Handler;
  accountId: number;
  renderButtonContent: RendererOf<number>;
  onNewAccountClick?: HandlerOf<string>;
  isModalInitiallyOpen?: boolean;
  placement?: Placement;
}

/*
 * Style.
 */

const StyledInlineEditingInputDisplay = styled(InlineEditingInputDisplay)`
  margin: 3px 0 2px 0;
  min-width: unset;
  max-width: 100%;
`;

const StyledPopoverCoordinator = styled(PopoverCoordinator)`
  width: 100%;
`;

const StyledValueButtonDiv = styled.div`
  display: flex;
  background: ${(p) => p.theme.greys.shade20};
  color: ${(p) => p.theme.greys.shade90};
  border-radius: 4px;
  padding: 7px 8px;
  margin: -2px 0;
`;

const StyledIcon = styled(Icon)`
  margin-left: 12px;
`;

/*
 * Component.
 */

export const InlineEditingAccountPopover: FC<InlineEditingAccountPopoverProps> = (props) => {
  const theme = useUserTheme();
  const {
    className,
    onEditSave,
    onEditCancel,
    accountId,
    renderButtonContent,
    onNewAccountClick,
    isModalInitiallyOpen = true,
    placement = 'bottom',
  } = props;

  return (
    <StyledInlineEditingInputDisplay>
      <StyledPopoverCoordinator
        renderButton={() => (
          <StyledValueButtonDiv className={className}>
            {renderButtonContent(accountId)}
            <StyledIcon name="chevronDownSmall" color={theme.greys.shade70} />
          </StyledValueButtonDiv>
        )}
        renderModal={(popoverProps) => (
          <SearchAccountsDropdown
            popoverProps={popoverProps}
            placement={placement}
            selectedAccountId={accountId}
            onConfirm={onEditSave}
            onNewAccountClick={onNewAccountClick}
          />
        )}
        onPopoverToggle={(isPopoverOpen) => {
          // User clicks out without selecting an option
          if (!isPopoverOpen) {
            onEditCancel();
          }
        }}
        isModalInitiallyOpen={isModalInitiallyOpen}
      />
    </StyledInlineEditingInputDisplay>
  );
};
